<!-- <app-breadcrumb [pageName]="'About Us'"></app-breadcrumb> -->
<main class="design-area ">
	<div class="container">
		<div class="row">
			<div class="col-md-12 text-center pb-5 about_ban_head" [innerHTML]="about">				
			</div>
		</div>
	</div>
</main>